import request from '@/utils/request'

//  登录
export const login = data => request({
    url: '/api/v1/account/login',
    method: 'post',
    data
})

//  注册
export const register = data => request({
    url: '/api/v1/account/register',
    method: 'post',
    data
})

//  发送邮箱验证码
export const sendEmail = data => request({
    url: '/api/v1/sendEmail',
    method: 'post',
    data
})

//  获取aws S3授权
export const awsS3Auth = data => request({
    url: '/api/v1/init/awsS3Auth',
    method: 'post',
    data
})

//  首页
export const home = data => request({
    url: '/api/v1/dashboard/home',
    method: 'post',
    data
})

//  获取用户信息
export const getUserInfo = data => request({
    url: '/api/v1/account/getUserInfo',
    method: 'post',
    data
})

//  修改用户名 / 头像
export const modify = data => request({
    url: '/api/v1/account/modify',
    method: 'post',
    data
})

//  修改登录密码
export const modifyLoginPassword = data => request({
    url: '/api/v1/account/modifyLoginPassword',
    method: 'post',
    data
})

//  忘记登录密码
export const forgetLoginPassword = data => request({
    url: '/api/v1/account/forgetLoginPassword',
    method: 'post',
    data
})

//  认证
export const approve = data => request({
    url: '/api/v1/account/approve',
    method: 'post',
    data
})

// 获取KYC详情
export const getKycInfo = data => request({
    url: '/api/v1/account/kyc/getKycInfo',
    method: 'post',
    data
})

// Corporate FI 保存
export const kyc_corporate = data => request({
    url: '/api/v1/account/kyc/corporate',
    method: 'post',
    data
})

// Company information 保存
export const kyc_company = data => request({
    url: '/api/v1/account/kyc/company',
    method: 'post',
    data
})

// Ownership/controller/shareholder information 保存
export const kyc_shareholder = data => request({
    url: '/api/v1/account/kyc/shareholder',
    method: 'post',
    data
})

// Trading authorization form 保存
export const kyc_trading = data => request({
    url: '/api/v1/account/kyc/trading',
    method: 'post',
    data
})

// KYC 提交审核
export const kyc_all_submit = data => request({
    url: '/api/v1/account/kyc/submit',
    method: 'post',
    data
})

// 联系客服发送消息
export const kyc_submit = data => request({
    url: '/api/v1/feedback/submit',
    method: 'post',
    data
})

// 退出登录
export const exitLogin = data => request({
    url: '/api/v1/account/exitLogin',
    method: 'post',
    data
})

// 充值 详情
export const details = data => request({
    url: '/api/v1/deposit/details',
    method: 'post',
    data
})

// 充值 记录
export const record = data => request({
    url: '/api/v1/deposit/record',
    method: 'post',
    data
})

// 充值 单个 记录详情
export const get = data => request({
    url: '/api/v1/deposit/get',
    method: 'post',
    data
})

// 法币 提币 交易记录
export const fiat_record = data => request({
    url: '/api/v1/withdraw/fiat/record',
    method: 'post',
    data
})

// 法币 提币 交易记录 详情
export const fiat_get = data => request({
    url: '/api/v1/withdraw/fiat/get',
    method: 'post',
    data
})

// 加密货币 提币 交易记录
export const crypto_record = data => request({
    url: '/api/v1/withdraw/crypto/record',
    method: 'post',
    data
})

// 加密货币 提币 交易记录 详情
export const crypto_get = data => request({
    url: '/api/v1/withdraw/crypto/get',
    method: 'post',
    data
})

// 充值 记录下载
export const deposit_download = data => request({
    url: '/api/v1/deposit/download',
    method: 'post',
    responseType: 'blob',
    data
})

// 提币 详情
export const withdraw_details = data => request({
    url: '/api/v1/withdraw/details',
    method: 'post',
    data
})

// 法币 提币 交易记录 下载
export const fiat_download = data => request({
    url: '/api/v1/withdraw/fiat/download',
    method: 'post',
    responseType: 'blob',
    data
})

// 加密货币 提币 交易记录 下载
export const crypto_download = data => request({
    url: '/api/v1/withdraw/crypto/download',
    method: 'post',
    responseType: 'blob',
    data
})

//  加密货币 提币 收款地址 列表
export const crypto_addressList = data => request({
    url: '/api/v1/withdraw/crypto/addressList',
    method: 'post',
    data
})

//  收款地址 新加
export const withdraw_address_add = data => request({
    url: '/api/v1/withdraw/address/add',
    method: 'post',
    data
})

//  收款地址 编辑
export const withdraw_address_edit = data => request({
    url: '/api/v1/withdraw/address/edit',
    method: 'post',
    data
})

//  收款地址 删除
export const withdraw_address_del = data => request({
    url: '/api/v1/withdraw/address/del',
    method: 'post',
    data
})

//  加密货币 提币
export const withdraw_crypto_withdraw = data => request({
    url: '/api/v1/withdraw/crypto/withdraw',
    method: 'post',
    data
})

//  收款地址 列表
export const withdraw_address_list = data => request({
    url: '/api/v1/withdraw/address/list',
    method: 'post',
    data
})

// (法币)  收款人 列表
export const withdraw_payee_list = data => request({
    url: '/api/v1/withdraw/payee/list',
    method: 'post',
    data
})

// (法币)  收款人 新加
export const withdraw_payee_add = data => request({
    url: '/api/v1/withdraw/payee/add',
    method: 'post',
    data
})

// (法币)  收款人 编辑
export const withdraw_payee_edit = data => request({
    url: '/api/v1/withdraw/payee/edit',
    method: 'post',
    data
})

// (法币)  收款人 删除
export const withdraw_payee_del = data => request({
    url: '/api/v1/withdraw/payee/del',
    method: 'post',
    data
})

// (法币)  法币 - 提币
export const withdraw_fiat_withdraw = data => request({
    url: '/api/v1/withdraw/fiat/withdraw',
    method: 'post',
    data
})

// 加密货币 提币 收款地址 检测
export const withdraw_crypto_check = data => request({
    url: '/api/v1/withdraw/crypto/check',
    method: 'post',
    data
})

// 交易记录
export const transaction_record = data => request({
    url: '/api/v1/transaction/record',
    method: 'post',
    data
})

// 交易记录下载
export const transaction_download = data => request({
    url: '/api/v1/transaction/download',
    method: 'post',
    responseType: 'blob',
    data
})

// 交易记录详情
export const transaction_get = data => request({
    url: '/api/v1/transaction/get',
    method: 'post',
    data
})

// 申请信用卡 - director信息列表
export const getDirectorList = data => request({
    url: '/api/v1/card/getDirectorList',
    method: 'post',
    data
})

// 申请信用卡
export const card_submit = data => request({
    url: '/api/v1/card/submit',
    method: 'post',
    data
})

// 申请记录
export const card_record = data => request({
    url: '/api/v1/card/record',
    method: 'post',
    data
})

// 申请信用卡 - 获取FEB Debit Card 配置
export const card_getConfig = data => request({
    url: '/api/v1/card/getConfig',
    method: 'post',
    data
})

// 申请信用卡 - 链接
export const linkSubmit_str = data => request({
    url: '/api/v1/card/linkSubmit',
    method: 'post',
    data
})

// 申请记录 -详情
export const card_get = data => request({
    url: '/api/v1/card/get',
    method: 'post',
    data
})

// 申请记录 - 审核
export const card_audit = data => request({
    url: '/api/v1/card/audit',
    method: 'post',
    data
})

// 申请记录 - 激活
export const card_active = data => request({
    url: '/api/v1/card/active',
    method: 'post',
    data
})

// 申请记录 - 获取充值配置
export const card_getTopUpConfig = data => request({
    url: '/api/v1/card/getTopUpConfig',
    method: 'post',
    data
})

// 申请记录 - 充值
export const card_topUp = data => request({
    url: '/api/v1/card/topUp',
    method: 'post',
    data
})

// 申请记录 - 充值记录
export const card_topRecord = data => request({
    url: '/api/v1/card/topRecord',
    method: 'post',
    data
})

// 申请记录 - 充值记录下载
export const card_download = data => request({
    url: '/api/v1/card/download',
    method: 'post',
    responseType: 'blob',
    data
})

// 谷歌令牌 - 登录
export const account_login = data => request({
    url: '/api/v1/account/login',
    method: 'post',
    data
})

// 谷歌令牌 - 验证
export const account_verify = data => request({
    url: '/api/v1/account/verify',
    method: 'post',
    data
})

// 首页home - 刷新余额
export const card_refreshData = data => request({
    url: '/api/v1/card/refreshData',
    method: 'post',
    data
})

// 充值 - 法币充值 submit
export const deposit_submit = data => request({
    url: '/api/v1/deposit/submit',
    method: 'post',
    data
})

// 修改卡密码
export const setPin = data => request({
    url: '/api/v1/card/setPin',
    method: 'post',
    data
})

// 获取卡的交易记录
export const transactionDetails = data => request({
    url: '/api/v1/card/transactionDetails',
    method: 'post',
    data
})

// 获取卡的交易记录 - 下载
export const transactionDownload = data => request({
    url: '/api/v1/card/transactionDownload',
    method: 'post',
    responseType: 'blob',
    data
})

// 充值 - 法币充值 获取配置
export const deposit_getConfig = data => request({
    url: '/api/v1/deposit/getConfig',
    method: 'post',
    data
})

// 加密货币 提币 - 计算手续费 以及到账数量
export const crypto_calc = data => request({
    url: '/api/v1/withdraw/crypto/calc',
    method: 'post',
    data
})

// 首页home - 获取激活卡的信息
export const getCardInfo = data => request({
    url: '/api/v1/dashboard/getCardInfo',
    method: 'post',
    data
})

// 首页home - 申请卡
export const dashboard_submit = data => request({
    url: '/api/v1/dashboard/submit',
    method: 'post',
    data
})

// 申请记录 - 充值 - 计算
export const card_calc = data => request({
    url: '/api/v1/card/calc',
    method: 'post',
    data
})

// my transaction USDT USDC 余额
export const transaction_details = data => request({
    url: '/api/v1/transaction/details',
    method: 'post',
    data
})

// 获取卡的交易记录-账户结单
export const transaction_statement = data => request({
    url: '/api/v1/card/transactionStatement',
    method: 'post',
    data
})

// 用户kyc列表
export const accountKycList = data => request({
    url: '/api/v1/card/accountKycList',
    method: 'post',
    data
})

// 更新用户ID kyc信息
export const updateIdKycInfo = data => request({
    url: '/api/v1/card/updateIdKycInfo',
    method: 'post',
    data
})

// 更新用户信息
export const updateAccountInfo = data => request({
    url: '/api/v1/card/updateAccountInfo',
    method: 'post',
    data
})

// 更新地址信息
export const updateAddressKycInfo = data => request({
    url: '/api/v1/card/updateAddressKycInfo',
    method: 'post',
    data
})

// card -详情
export const card_details = data => request({
    url: '/api/v1/card/getCardKyc',
    method: 'post',
    data
})

// 冻结卡
export const card_block = data => request({
    url: '/api/v1/dashboard/block',
    method: 'post',
    data
})

// 解冻卡
export const card_unblock = data => request({
    url: '/api/v1/dashboard/unblock',
    method: 'post',
    data
})

// 公告列表
export const list = data => request({
    url: '/api/v1/msg/list',
    method: 'post',
    data
})

// 公告列表 - 已读
export const read = data => request({
    url: '/api/v1/msg/read',
    method: 'post',
    data
})

// 公告列表 - 未读数量
export const count = data => request({
    url: '/api/v1/msg/count',
    method: 'post',
    data
})

// 获取卡邮寄地址 年费 补卡费 年费截止时间信息
export const getCardConfig = data => request({
    url: '/api/v1/dashboard/getCardConfig',
    method: 'post',
    data
})
// ***
// 获取卡邮寄地址 补卡费
export const getReplaceConfig = data => request({
    url: '/api/v1/dashboard/getReplaceConfig',
    method: 'post',
    data
})
// 获取卡年费数据
export const getAnnualConfig = data => request({
    url: '/api/v1/dashboard/getAnnualConfig',
    method: 'post',
    data
})

// 补卡
export const replace = data => request({
    url: '/api/v1/dashboard/replace',
    method: 'post',
    data
})

// 年费 是否自动续费设置
export const annualSetting = data => request({
    url: '/api/v1/dashboard/annualSetting',
    method: 'post',
    data
})

// 年费记录列表
export const renewList = data => request({
    url: '/api/v1/dashboard/renewList',
    method: 'post',
    data
})

// 公告列表 - 清除未读
export const clear = data => request({
    url: '/api/v1/msg/clear',
    method: 'post',
    data
})

// 首页弹框公告列表
export const msg_box = data => request({
    url: '/api/v1/msg/box',
    method: 'post',
    data
})

// 续费
export const renew = data => request({
    url: '/api/v1/dashboard/renew',
    method: 'post',
    data
})

// 验证用户名
export const verifyUsername = data => request({
    url: '/api/v1/card/verifyUsername',
    method: 'post',
    data
})

// 验证邮箱验证码
export const verifyCode = data => request({
    url: '/api/v1/card/verifyCode',
    method: 'post',
    data
})

// 更新用户信息
export const updateMemberInfo = data => request({
    url: '/api/v1/card/updateMemberInfo',
    method: 'post',
    data
})

// 验证登录密码
export const verifyLoginPassword = data => request({
    url: '/api/v1/account/verifyLoginPassword',
    method: 'post',
    data
})

// 个人消息列表-删除已读
export const msg_delete = data => request({
    url: '/api/v1/msg/delete',
    method: 'post',
    data
})

// 修改协议状态
export const modifyProtocolStatus = data => request({
    url: '/api/v1/account/modifyProtocolStatus',
    method: 'post',
    data
})

// 重新生成KYC验证URL
export const regenerateKycVerificationURL = data => request({
    url: '/api/v1/card/regenerateKycVerificationURL',
    method: 'post',
    data
})
